import { Route, UrlMatchResult, UrlSegment } from '@angular/router';

import {
  PageChangelogComponent,
  PageLoginComponent,
  PageMaintenanceComponent,
  PageOauth2LandingComponent,
  PagePwdResetComponent,
  PageResetRequestComponent,
} from '@infodata-group/inf-commons-desktop';
import { authorizationGuardFn } from '@infodata-group/inf-commons';

function planningMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length === 0 || segments[0].path !== 'planning') {
    return null;
  }
  switch (segments.length) {
    case 1:
      return { consumed: segments };
    case 2:
      return {
        consumed: segments,
        posParams: { preselection: segments[1] },
      };
    default:
      return null;
  }
}

export const routes: Route[] = [
  { path: 'login', component: PageLoginComponent },
  { path: 'reset-request', component: PageResetRequestComponent },
  { path: 'reset-password', component: PagePwdResetComponent },
  { path: 'oauth2', component: PageOauth2LandingComponent },
  { path: 'maintenance', component: PageMaintenanceComponent },
  {
    path: 'init',
    loadComponent: () =>
      import('./page/page-init/page-init.component').then(
        (m) => m.PageInitComponent,
      ),
    canActivate: [authorizationGuardFn],
  },
  { path: '', redirectTo: 'init', pathMatch: 'full' },
  { path: 'planning', redirectTo: 'init', pathMatch: 'full' },
  {
    path: 'main',
    loadComponent: () =>
      import('./page/page-main/page-main.component').then(
        (m) => m.PageMainComponent,
      ),
    canActivate: [authorizationGuardFn],
    children: [
      { path: 'changelogs', component: PageChangelogComponent },
      {
        matcher: planningMatcher,
        loadComponent: () =>
          import('./page/page-planning/page-planning.component').then(
            (m) => m.PagePlanningComponent,
          ),
      },
      {
        path: 'administration',
        loadComponent: () =>
          import('./page/page-preference/page-preference.component').then(
            (m) => m.PagePreferenceComponent,
          ),
      },
    ],
  },
];
